export default "__VITE_ASSET__DC360wnA__"